import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueResource from 'vue-resource'
import CKEditor from '@ckeditor/ckeditor5-vue'
import store from './store'
import './plugins/base'
import './plugins/chartist'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import VueSession from 'vue-session'
import VueHtmlToPaper from 'vue-html-to-paper'
require('./plugins/fontawesome/css/all.css')

require('./plugins/custom.css')
Vue.use(VueResource)
Vue.use(CKEditor)
Vue.use(VueSession)
Vue.config.productionTip = false
Vue.use(require('vue-moment-jalaali'))
Vue.http.options.root = process.env.VUE_APP_API_BASEURL
Vue.http.headers.common['Content-Type'] = 'application/json;charset=UTF-8'
Vue.http.headers.common['g-platform'] = process.env.VUE_APP_G_PLATFROM
Vue.http.headers.common['g-api-key'] = process.env.VUE_APP_G_API_KEY
if (Vue.prototype.$session.exists()) {
  Vue.http.headers.common.token = Vue.prototype.$session.get('jwtToken')
}
Vue.use(VueHtmlToPaper, {
  styles: [
    '../print.css',
  ],
})

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app')
